import axiosClient from "./axiosClient";

const translateApi = {
    translate: (data) =>{
        const url = `api/translate`
        return axiosClient.post(url,data)
    },
}
export default translateApi;